import { useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { createSupabaseClient } from "../../../hooks/useSupabase";

export type CenterRadiologist = {
  id: string;
  firstName: string;
  lastName: string;
};

type RawRow = {
  id: string;
  first_name: string;
  last_name: string;
};

const useCenterRadiologists = (centerId: string) => {
  const supabase = useMemo(() => createSupabaseClient(), []);

  return useQuery({
    queryKey: ["center-radiologists", centerId],
    queryFn: async () => {
      const { data, error } = await supabase
        .from("center_users")
        .select("id, first_name, last_name, center_user_configs!inner(*)")
        .eq("primary_center_id", centerId)
        .eq("center_user_configs.has_availability_calendar", true);

      if (error) throw new Error(error.message);

      return (data as RawRow[]).map((user) => ({
        id: user.id,
        firstName: user.first_name,
        lastName: user.last_name,
      }));
    },
    enabled: !!centerId,
  });
};

export default useCenterRadiologists;
